import { useQuery, useQueryClient } from '@tanstack/react-query'
import { SubscriptionService } from '@/services/subscription-service'

// Query keys
export const subscriptionQueryKeys = {
  all: ['subscriptions'] as const,
  subscription: (userId: string) => ['subscriptions', userId] as const,
}

// Subscription query hook
export function useSubscriptionQuery(userId: string | undefined) {
  return useQuery({
    queryKey: subscriptionQueryKeys.subscription(userId || ''),
    queryFn: () => SubscriptionService.getUserPlan(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // Consider fresh for 5 minutes
    gcTime: 10 * 60 * 1000,   // Keep in cache for 10 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}

// Hook to invalidate subscription cache (useful after upgrade/changes)
export function useInvalidateSubscriptionCache() {
  const queryClient = useQueryClient()

  return (userId: string) => {
    queryClient.invalidateQueries({
      queryKey: subscriptionQueryKeys.subscription(userId),
    })
  }
}